(() => {
  // app/scripts/common/function/compare.js
  function Compare(value) {
    const key = value;
    const { sessionStorage } = theme;
    const Storage = sessionStorage(key);
    const Compare2 = {
      get: () => {
        const data = Storage.get();
        return data ? data.split(",") : [];
      },
      set: (value2) => {
        Storage.set(value2);
        Compare2.dispatchEvent();
      },
      addItem: (value2) => {
        let data = Compare2.get();
        data = data.filter((item) => item != value2);
        data.push(value2);
        Storage.set(data.join(","));
        Compare2.dispatchEvent();
      },
      removeItem: (value2) => {
        let data = Compare2.get();
        data = data.filter((item) => item != value2);
        Storage.set(data);
        Compare2.dispatchEvent();
      },
      clearAll: () => {
        Storage.clearAll();
        Compare2.dispatchEvent();
      },
      dispatchEvent: () => {
        window.dispatchEvent(new CustomEvent(`compare:change`));
      }
    };
    return Compare2;
  }

  // app/scripts/compare-popup.js
  var { settings: { compareSection, compareKey, compareClass }, routes: { rootUrl } } = theme;
  (() => {
    let compareObj = Compare(compareKey);
    compareObj.clearAll();
  })();
  let popupRequest, lastCompareTrigger, initialRecovery, initialFocus, initialBackgroundFocus;
  function watchComparisonFocus(owner, element, index = 0) {
    let active = true;
    const cancel = () => {
      active = false;
      for (const name of ["pointerdown", "click", "keydown", "wheel", "touchstart"]) document.removeEventListener(name, cancel, true);
      document.removeEventListener("focusin", moved, true);
      window.removeEventListener("blur", cancel);
    };
    const moved = (event) => { if (event.target !== element) cancel(); };
    for (const name of ["pointerdown", "click", "keydown", "wheel", "touchstart"]) document.addEventListener(name, cancel, true);
    document.addEventListener("focusin", moved, true);
    window.addEventListener("blur", cancel);
    return {owner, element, index, cancel, canRestore: () => active && element.isConnected && document.activeElement === element};
  }
  function comparisonRecovery(onRetry, onClear) {
    const strings = window.espAccessibilityStrings || {};
    const element = document.createElement("div");
    element.setAttribute("data-compare-feedback", "");
    const message = document.createElement("p");
    message.setAttribute("role", "alert");
    message.setAttribute("aria-atomic", "true");
    const retry = document.createElement("button"), clear = document.createElement("button");
    retry.type = clear.type = "button";
    retry.className = "btn btn-2";
    clear.className = "btn btn-2";
    retry.setAttribute("data-compare-retry", "");
    clear.setAttribute("data-compare-clear", "");
    retry.textContent = strings.compareRetry || "Try comparison again";
    clear.textContent = strings.compareClear || "Clear all";
    element.append(message, retry, document.createTextNode(" "), clear);
    let busy = false;
    const recovery = {
      element, retry,
      show: () => { message.textContent = strings.compareError || "Comparison could not be loaded. Your selections are saved. Try again or clear your selection."; },
      setBusy: (value) => {
        busy = value;
        retry.setAttribute("aria-disabled", String(value));
        element.setAttribute("aria-busy", String(value));
        if (value) message.textContent = "";
      }
    };
    retry.addEventListener("click", (event) => {
      event.preventDefault(); event.stopPropagation();
      if (busy) return;
      recovery.setBusy(true);
      Promise.resolve().then(() => onRetry(retry)).catch(() => recovery.show()).finally(() => recovery.setBusy(false));
    });
    clear.addEventListener("click", (event) => {
      event.preventDefault(); event.stopPropagation();
      onClear(clear);
    });
    return recovery;
  }
  function clearInitialRecovery() {
    initialRecovery?.element.remove();
    initialRecovery = null;
    initialFocus?.cancel();
    initialFocus = null;
    initialBackgroundFocus?.cancel();
    initialBackgroundFocus = null;
  }
  function showInitialRecovery() {
    if (!lastCompareTrigger?.isConnected) return;
    if (initialRecovery && !initialRecovery.element.isConnected) clearInitialRecovery();
    if (!initialRecovery) {
      initialRecovery = comparisonRecovery((retry) => {
        initialFocus?.cancel();
        initialFocus = watchComparisonFocus(null, retry);
        return loadPopupCompare();
      }, (clear) => {
        const restore = document.activeElement === clear;
        Compare(compareKey).clearAll();
        if (restore && lastCompareTrigger?.isConnected) lastCompareTrigger.focus();
      });
      lastCompareTrigger.closest("compare-button").after(initialRecovery.element);
    }
    initialRecovery.show();
  }
  function loadPopupCompare() {
    const compareObj = Compare(compareKey);
    const compareData = compareObj.get();
    if (!compareData.length || popupRequest) return popupRequest;
    const trigger = lastCompareTrigger;
    popupRequest = fetch(`${rootUrl}?section_id=${compareSection}`).then((response) => {
      if (response.ok === false) throw new Error("Comparison popup unavailable");
      return response.text();
    }).then((html) => {
      const content = html.split("<!-- split -->")[1];
      const parsed = document.createElement("template");
      parsed.innerHTML = content || "";
      if (!parsed.content.querySelector("#compareMiniPopup compare-component .jsResult") || !parsed.content.querySelector("#compareDetailsPopup compare-detail-component .jsResultItemsFeatures")) throw new Error("Invalid comparison popup");
      const currentTrigger = lastCompareTrigger || trigger;
      if (!compareObj.get().length || currentTrigger && !currentTrigger.isConnected) return;
      if (!document.querySelector("compare-component")) document.body.insertAdjacentHTML("beforeend", content);
      const component = document.querySelector("compare-component");
      if (initialFocus) {
        component.pendingFocus?.cancel();
        component.pendingFocus = initialFocus;
        component.pendingFocus.owner = component;
        initialFocus = null;
      }
      return component.dataRequest;
    }).catch(() => {
      const currentTrigger = lastCompareTrigger || trigger;
      if (compareObj.get().length && (!currentTrigger || currentTrigger.isConnected) && !document.querySelector("compare-component")) {
        initialFocus?.cancel();
        initialFocus = null;
        showInitialRecovery();
      }
    }).finally(() => { popupRequest = null; });
    return popupRequest;
  }
  window.addEventListener(`compare:change`, (e) => {
    if (!Compare(compareKey).get().length) clearInitialRecovery();
    !document.querySelector("compare-component") && loadPopupCompare();
  });
  customElements.define("compare-button", class extends HTMLElement {
    constructor() {
      super();
      this.onCompareChange = () => this.updateState();
      this.addEventListener("click", this.onClick.bind(this));
    }
    connectedCallback() {
      this.handle = this.dataset.handle;
      this.Compare = Compare(compareKey);
      this.updateState();
      window.addEventListener("compare:change", this.onCompareChange);
    }
    disconnectedCallback() {
      window.removeEventListener("compare:change", this.onCompareChange);
    }
    updateState() {
      this.setActive = this.Compare.get().includes(this.handle);
    }
    set setActive(value) {
      this.classList.toggle(compareClass, value);
      this.querySelector("button")?.setAttribute("aria-pressed", String(Boolean(value)));
    }
    onClick(event) {
      if (!event.target.closest("button") || !this.handle) return;
      lastCompareTrigger = event.target.closest("button");
      if (!document.querySelector("compare-component")) {
        initialBackgroundFocus?.cancel();
        initialBackgroundFocus = document.activeElement === lastCompareTrigger ? watchComparisonFocus(null, lastCompareTrigger) : null;
      }
      const { Compare: Compare2, handle: value } = this;
      const data = Compare2.get();
      if (data.includes(value)) {
        Compare2.removeItem(value);
        this.setActive = false;
        return;
      }
      Compare2.addItem(value);
      this.setActive = true;
    }
  });
  customElements.define("compare-component", class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", ({ target }) => {
        target.closest(".jsCompareToggle:not(:disabled)") && this.popupToggle();
        target.closest(".jsCompareRemove") && this.clearItem(target);
        target.closest(".jsCompareClearAll") && this.clearAll();
      });
      this.onCompareChange = () => this.initialize();
      this.requestVersion = 0;
      this.recovery = new Map();
      this.onBackgroundFocus = () => {
        this.backgroundFocusTarget = document.activeElement;
        this.scheduleBackgroundReveal();
      };
      this.onBackgroundLayout = () => this.scheduleBackgroundReveal();
      this.onBackgroundIntent = (event) => {
        this.cancelBackgroundReveal();
        this.backgroundFocusTarget = null;
        const button = event.target.closest?.("compare-button button");
        if (button === document.activeElement && (event.type === "click" || event.type === "keydown" && ["Enter", " "].includes(event.key))) {
          this.backgroundFocusTarget = button;
          this.scheduleBackgroundReveal();
        }
      };
      this.onPopupDismiss = (event) => {
        const popup = this.closest("popup-component");
        if (!popup?.isActive) return;
        const escape = event.type === "keydown" && event.key === "Escape" && !event.target.closest("details[open]");
        const outside = event.type === "click" && (!event.target.closest(".jsContent,.popup__content") || event.target.closest(".jsClose"));
        if (escape || outside) this.dismissedRequestVersion = this.requestVersion;
      };
    }
    connectedCallback() {
      this.detailLayoutName = "compare-detail-component";
      this.defaultLayout ??= this.querySelector(".jsResult").innerHTML;
      this.Compare = Compare(compareKey);
      window.addEventListener("compare:change", this.onCompareChange);
      this.popupOwner = this.closest("popup-component");
      this.popupOwner.addEventListener("keydown", this.onPopupDismiss, true);
      this.popupOwner.addEventListener("click", this.onPopupDismiss, true);
      document.addEventListener("focusin", this.onBackgroundFocus);
      window.addEventListener("resize", this.onBackgroundFocus);
      window.addEventListener("blur", this.onBackgroundIntent);
      for (const name of ["keydown", "pointerdown", "click", "wheel", "touchstart"]) document.addEventListener(name, this.onBackgroundIntent, true);
      this.popupOwner.addEventListener("transitionend", this.onBackgroundLayout);
      this.backgroundPopupObserver = new MutationObserver(this.onBackgroundLayout);
      this.backgroundPopupObserver.observe(this.popupOwner, { attributes: true, attributeFilter: ["aria-hidden"] });
      if (typeof ResizeObserver !== "undefined") {
        this.backgroundSizeObserver = new ResizeObserver(this.onBackgroundLayout);
        this.backgroundSizeObserver.observe(this);
      }
      // The first product request can insert the tray after its trigger received focus.
      if (initialBackgroundFocus?.canRestore()) this.backgroundFocusTarget = initialBackgroundFocus.element;
      initialBackgroundFocus?.cancel();
      initialBackgroundFocus = null;
      this.initialize();
    }
    disconnectedCallback() {
      window.removeEventListener("compare:change", this.onCompareChange);
      this.popupOwner?.removeEventListener("keydown", this.onPopupDismiss, true);
      this.popupOwner?.removeEventListener("click", this.onPopupDismiss, true);
      document.removeEventListener("focusin", this.onBackgroundFocus);
      window.removeEventListener("resize", this.onBackgroundFocus);
      window.removeEventListener("blur", this.onBackgroundIntent);
      for (const name of ["keydown", "pointerdown", "click", "wheel", "touchstart"]) document.removeEventListener(name, this.onBackgroundIntent, true);
      this.popupOwner?.removeEventListener("transitionend", this.onBackgroundLayout);
      this.backgroundPopupObserver?.disconnect();
      this.backgroundSizeObserver?.disconnect();
      this.cancelBackgroundReveal();
      this.backgroundFocusTarget = null;
      this.pendingFocus?.cancel();
      this.clearRecovery();
      this.requestVersion++;
    }
    cancelBackgroundReveal() {
      cancelAnimationFrame(this.backgroundRevealFrame);
      this.backgroundReveal = null;
    }
    scheduleBackgroundReveal() {
      this.cancelBackgroundReveal();
      const target = this.backgroundFocusTarget, popup = this.popupOwner;
      if (!popup?.isActive || !target || document.activeElement !== target || popup.contains(target)) return;
      const pending = this.backgroundReveal = { target };
      this.backgroundRevealFrame = requestAnimationFrame(() => {
        this.backgroundRevealFrame = requestAnimationFrame(() => {
          if (this.backgroundReveal !== pending) return;
          this.backgroundReveal = null;
          if (!this.isConnected || !popup.isActive || !target.isConnected || document.activeElement !== target || popup.contains(target) || !target.getClientRects().length || document.querySelector('popup-component[aria-modal="true"][aria-hidden="false"]')) return;
          const root = document.scrollingElement || document.documentElement;
          for (let node = target; node && node !== root; node = node.parentElement) {
            const style = getComputedStyle(node);
            if (node.matches('[hidden],[inert],[aria-hidden="true"]') || style.display === "none" || style.visibility === "hidden" || ["fixed", "sticky"].includes(style.position)) return;
            if (node.tagName === "DETAILS" && !node.open && !node.querySelector(":scope > summary")?.contains(target)) return;
            if (node !== document.body && /auto|scroll/.test(style.overflowY) && node.scrollHeight > node.clientHeight) return;
          }
          const rect = target.getBoundingClientRect(), tray = popup.getBoundingClientRect();
          if (rect.height <= 0 || tray.height <= 0 || tray.top >= window.innerHeight) return;
          let top = 0, bottom = Math.min(window.innerHeight, tray.top);
          for (const header of document.querySelectorAll("header")) {
            const style = getComputedStyle(header), box = header.getBoundingClientRect();
            if (["fixed", "sticky"].includes(style.position) && style.visibility !== "hidden" && box.top <= 0 && box.bottom > 0 && box.left < rect.right && box.right > rect.left) top = Math.max(top, box.bottom);
          }
          if (bottom - top <= 8) return;
          top += 4; bottom -= 4;
          let delta = 0;
          if (rect.height > bottom - top) {
            // Keep a reachable edge of oversized controls without oscillating.
            if (rect.bottom > top && rect.top < bottom) return;
            delta = rect.top >= bottom ? rect.top - top : rect.bottom - bottom;
          } else {
            delta = rect.top < top ? rect.top - top : rect.bottom > bottom ? rect.bottom - bottom : 0;
          }
          const next = Math.max(0, Math.min(root.scrollHeight - root.clientHeight, root.scrollTop + delta));
          if (Math.abs(next - root.scrollTop) > 0.5) window.scrollTo({ top: next, left: window.scrollX, behavior: "instant" });
        });
      });
    }
    get getStoreData() {
      const limit = +this.dataset.limit || 4;
      const data = this.Compare.get();
      if (data.length > limit) {
        data.reverse();
        data.length = limit;
        data.reverse();
        this.Compare.set(data);
      }
      return data;
    }
    initialize() {
      const data = this.getStoreData;
      if (!data.length) {
        this.requestVersion++;
        this.pendingFocus?.cancel();
        this.pendingFocus = null;
        this.clearRecovery();
        this.removeAttribute("aria-busy");
        this.querySelectorAll(".jsCompareToggle").forEach((button) => { button.disabled = true; });
        this.toggle = false;
        this.resetLayout();
        const details = document.querySelector(this.detailLayoutName);
        details?.closest("popup-component")?.close();
        details?.resetLayout?.();
        return;
      }
      this.dataRequest = this.getData(data);
      return this.dataRequest;
    }
    clearItem(target) {
      const button = target.closest(".jsCompareRemove");
      if (!button) return;
      this.rememberRemovalFocus(this, button);
      const value = button.dataset.handle;
      this.Compare.removeItem(value);
    }
    clearAll() {
      this.Compare.clearAll();
      this.toggle = false;
    }
    rememberRemovalFocus(owner, button) {
      this.pendingFocus?.cancel();
      this.pendingFocus = null;
      if (document.activeElement === button || button.contains(document.activeElement)) this.pendingFocus = watchComparisonFocus(owner, button, Math.max(0, [...owner.querySelectorAll(".jsCompareRemove")].indexOf(button)));
    }
    clearRecovery() {
      this.recovery.forEach((record, owner) => {
        record.element.remove();
        owner.querySelector(".jsResult,.compare-table-details")?.removeAttribute("hidden");
        owner.querySelector(".compare-button-group")?.removeAttribute("hidden");
      });
      this.recovery.clear();
      clearInitialRecovery();
    }
    showRecovery() {
      for (const owner of [this, document.querySelector(this.detailLayoutName)]) {
        if (!owner?.isConnected) continue;
        owner.querySelector(".jsResult,.compare-table-details")?.setAttribute("hidden", "");
        owner.querySelector(".compare-button-group")?.setAttribute("hidden", "");
        let record = this.recovery.get(owner);
        if (!record) {
          record = comparisonRecovery((retry) => {
            this.rememberRemovalFocus(owner, retry);
            return this.initialize();
          }, () => this.clearAll());
          (owner.querySelector(".compare-body") || owner).prepend(record.element);
          this.recovery.set(owner, record);
        }
        record.setBusy(false);
        record.show();
      }
    }
    async getData(array) {
      const version = ++this.requestVersion;
      const popup = this.closest("popup-component"), startedOpen = Boolean(popup.isActive);
      const canPresent = () => this.dismissedRequestVersion !== version && (!startedOpen || popup.isActive) && !document.querySelector('popup-component[aria-modal="true"][aria-hidden="false"]:not(#compareDetailsPopup)');
      this.setAttribute("aria-busy", "true");
      this.recovery.forEach((record) => record.setBusy(true));
      this.querySelectorAll(".jsCompareToggle").forEach((button) => { button.disabled = true; });
      try {
        const html = await Promise.all(array.map((handle) => this.getProduct(handle)));
        if (!this.isConnected || version !== this.requestVersion || this.Compare.get().join(",") !== array.join(",")) return;
        const miniLayout = html.map((item) => item.split("<!-- /// -->")[0]);
        const detailLayout = html.map((item) => [item.split("<!-- /// -->")[1], item.split("<!-- /// -->")[2]]);
        const pending = this.pendingFocus;
        const restoreFocus = pending?.canRestore();
        pending?.cancel();
        this.pendingFocus = null;
        this.setData = miniLayout;
        const details = document.querySelector(this.detailLayoutName);
        if (details) details.setData = detailLayout;
        this.clearRecovery();
        this.querySelectorAll(".jsCompareToggle").forEach((button) => { button.disabled = array.length < 2; });
        // A late product response must not reopen the mini tray over the details dialog.
        if (!details?.closest("popup-component").isActive && canPresent()) this.toggle = true;
        if (restoreFocus && pending.owner.closest("popup-component").isActive) {
          const buttons = [...pending.owner.querySelectorAll(".jsCompareRemove")];
          (buttons[Math.min(pending.index, buttons.length - 1)] || pending.owner.querySelector(".jsCompareToggle:not(:disabled),.jsCompareClearAll"))?.focus();
        }
      } catch {
        if (!this.isConnected || version !== this.requestVersion || this.Compare.get().join(",") !== array.join(",")) return;
        const pending = this.pendingFocus, restore = pending?.canRestore();
        pending?.cancel();
        this.pendingFocus = null;
        const details = document.querySelector(this.detailLayoutName);
        const focused = document.activeElement;
        const hiddenFocusOwner = [this, details].find((owner) => owner?.querySelector(".jsResult,.compare-table-details")?.contains(focused));
        this.showRecovery();
        clearInitialRecovery();
        if (!details?.closest("popup-component").isActive && canPresent()) this.toggle = true;
        const owner = restore ? pending.owner : hiddenFocusOwner;
        if (owner?.closest("popup-component")?.isActive) this.recovery.get(owner)?.retry.focus();
      } finally {
        if (version === this.requestVersion) this.removeAttribute("aria-busy");
      }
    }
    getProduct(handle) {
      const { productUrl } = this.dataset;
      const url = productUrl.replace("productHandle", handle);
      return fetch(url).then((response) => {
        if (response.ok === false) throw new Error("Comparison product unavailable");
        return response.text();
      }).then((html) => {
        const result = html.split("<!-- split -->")[1];
        if (!result || result.split("<!-- /// -->").length < 3) throw new Error("Invalid comparison product");
        const parts = result.split("<!-- /// -->");
        for (const [index, selector] of [[0, ".mini-compare-item"], [1, ".compare-item"]]) {
          const parsed = document.createElement("template");
          parsed.innerHTML = parts[index];
          if (!parsed.content.firstElementChild?.matches(selector)) throw new Error("Invalid comparison product layout");
        }
        return result;
      });
    }
    set setData(values) {
      this.resetLayout();
      this.querySelectorAll(".jsCompareItem").forEach((item, index) => {
        const html = values[index];
        if (!html)
          return;
        const div = document.createElement("div");
        div.innerHTML = html;
        item.replaceWith(div.firstElementChild);
      });
    }
    resetLayout() {
      this.querySelector(".jsResult").innerHTML = this.defaultLayout;
    }
    popupToggle() {
      this.toggle = false;
      const comparePopup = document.querySelector(this.detailLayoutName);
      comparePopup.closest("popup-component").open();
    }
    set toggle(value) {
      if (value)
        this.closest("popup-component").open();
      else
        this.closest("popup-component").close();
    }
  });
  customElements.define("compare-detail-component", class extends HTMLElement {
    connectedCallback() {
      this.onComparisonFocus ??= () => this.scheduleHorizontalReveal();
      this.onComparisonResize ??= () => this.scheduleHorizontalReveal();
      this.onComparisonIntent ??= (event) => {
        if (event.type !== "keydown" || event.key !== "Tab") this.cancelHorizontalReveal();
      };
      this.addEventListener("focusin", this.onComparisonFocus);
      window.addEventListener("resize", this.onComparisonResize);
      for (const name of ["keydown", "pointerdown", "click", "wheel", "touchstart"]) document.addEventListener(name, this.onComparisonIntent, true);
      window.addEventListener("blur", this.onComparisonIntent);
      if (this.initialized) return;
      this.initialized = true;
      this.defaultLayout = this.querySelector(".jsResultItems").innerHTML;
      this.defaultFeaturesLayout = this.querySelector(".jsResultItemsFeatures").innerHTML;
      this.Compare = Compare(compareKey);
      this.addEventListener("click", ({ target }) => {
        target.closest(".jsCompareToggle") && this.popupToggle();
        target.closest(".jsCompareRemove") && this.clearItem(target);
        target.closest(".jsCompareClearAll") && this.clearAll();
        target.closest(".card-details") && this.toggleDetails(target.closest("details"));
      });
      this.addEventListener("touchmove", this.onTouch.bind(this));
      this.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && !event.target.closest("details[open]")) {
          event.preventDefault();
          event.stopPropagation();
          this.popupToggle();
        }
      });
      this.closest("popup-component").addEventListener("click", (event) => {
        if (event.target.closest(".jsContent") || !this.closest("popup-component").isActive) return;
        event.preventDefault();
        event.stopPropagation();
        this.popupToggle();
      }, true);
    }
    popupToggle() {
      const comparePopup = document.querySelector("compare-component");
      this.closest("popup-component").close();
      if (!comparePopup || !this.Compare.get().length) return;
      const miniPopup = comparePopup.closest("popup-component");
      const fallbackFocus = document.activeElement;
      miniPopup.open();
      const attempt = {};
      const started = performance.now();
      this.returnFocusAttempt = attempt;
      const focusMini = () => {
        if (this.returnFocusAttempt !== attempt || !this.isConnected || !miniPopup.isActive || this.closest("popup-component").isActive) return;
        // Do not steal focus if the customer already moved to another control.
        if (document.activeElement !== fallbackFocus && document.activeElement !== document.body) return;
        const target = comparePopup.querySelector(".compare-all:not(:disabled)") || comparePopup.querySelector(".jsCompareRemove,.jsCompareClearAll");
        if (!target) return;
        target.focus({ preventScroll: true });
        // The tray may still be hidden during its opening transition. Retry
        // only this return destination, while the original fallback has focus.
        if (document.activeElement !== target && performance.now() - started < 750) this.returnFocusFrame = requestAnimationFrame(focusMini);
      };
      cancelAnimationFrame(this.returnFocusFrame);
      focusMini();
    }
    disconnectedCallback() {
      this.returnFocusAttempt = null;
      cancelAnimationFrame(this.returnFocusFrame);
      this.cancelHorizontalReveal();
      this.removeEventListener("focusin", this.onComparisonFocus);
      window.removeEventListener("resize", this.onComparisonResize);
      for (const name of ["keydown", "pointerdown", "click", "wheel", "touchstart"]) document.removeEventListener(name, this.onComparisonIntent, true);
      window.removeEventListener("blur", this.onComparisonIntent);
    }
    cancelHorizontalReveal() {
      cancelAnimationFrame(this.horizontalRevealFrame);
      this.horizontalReveal = null;
    }
    scheduleHorizontalReveal() {
      this.cancelHorizontalReveal();
      const target = document.activeElement, table = this.querySelector(".compare-table-details");
      if (!this.closest("popup-component")?.isActive || !table?.contains(target)) return;
      const pending = this.horizontalReveal = {target, table};
      this.horizontalRevealFrame = requestAnimationFrame(() => {
        this.horizontalRevealFrame = requestAnimationFrame(() => {
          if (this.horizontalReveal !== pending) return;
          this.horizontalReveal = null;
          if (!this.isConnected || !table.isConnected || !target.isConnected || document.activeElement !== target || !this.closest("popup-component")?.isActive || !table.contains(target) || !target.getClientRects().length) return;
          for (let node = target; node; node = node.parentElement) {
            if (node.matches('[hidden],[inert],[aria-hidden="true"]') || getComputedStyle(node).display === "none" || getComputedStyle(node).visibility === "hidden") return;
            if (node.tagName === "DETAILS" && !node.open && !node.querySelector(":scope > summary")?.contains(target)) return;
          }
          if (table.scrollWidth <= table.clientWidth) return;
          const box = table.getBoundingClientRect(), rect = target.getBoundingClientRect();
          let left = Math.max(0, box.left + table.clientLeft), right = Math.min(window.innerWidth, box.left + table.clientLeft + table.clientWidth);
          if (right <= left || rect.width <= 0) return;
          const inset = right - left > 8 ? 4 : 0;
          left += inset; right -= inset;
          let delta = 0;
          if (rect.width > right - left) {
            // An oversized control cannot fit; keep one reachable edge stable.
            if (Math.abs(rect.left - left) <= 0.5 || Math.abs(rect.right - right) <= 0.5) return;
            delta = rect.right < right ? rect.right - right : rect.left - left;
          } else {
            delta = rect.left < left ? rect.left - left : rect.right > right ? rect.right - right : 0;
          }
          const next = Math.max(0, Math.min(table.scrollWidth - table.clientWidth, table.scrollLeft + delta));
          if (Math.abs(next - table.scrollLeft) > 0.5) table.scrollLeft = next;
        });
      });
    }
    clearItem(target) {
      const button = target.closest(".jsCompareRemove");
      if (!button) return;
      document.querySelector("compare-component")?.rememberRemovalFocus(this, button);
      const value = button.dataset.handle;
      this.Compare.removeItem(value);
    }
    clearAll() {
      document.querySelector("compare-component")?.clearAll();
    }
    resetLayout() {
      this.querySelector(".jsResultItems").innerHTML = this.defaultLayout;
      this.querySelector(".jsResultItemsFeatures").innerHTML = this.defaultFeaturesLayout;
    }
    set setData(values) {
      this.resetLayout();
      const compareItems = this.querySelectorAll(".jsCompareItem");
      compareItems.forEach((item, index) => {
        if (!values[index])
          return;
        const itemLayout = values[index][0];
        const featuresLayout = values[index][1];
        const divItem = document.createElement("div");
        divItem.innerHTML = itemLayout;
        compareItems[index].replaceWith(divItem.firstElementChild);
        const featuresList = document.createElement("div");
        featuresList.innerHTML = featuresLayout;
        featuresList.querySelectorAll(".jsCompareFeatures").forEach((item2) => {
          const currentLine = this.querySelector(`.jsCompareFeatures[data-index="${index}"][data-key="${item2.dataset.key}"]`);
          if (!currentLine) return;
          currentLine.innerHTML = item2.innerHTML;
          currentLine.classList.add("filled");
        });
      });
      this.querySelectorAll("compare-group-feature").forEach((item) => item.update());
      this.updateTableSemantics(values.length);
    }
    updateTableSemantics(count) {
      const table = this.querySelector(".compare-table-details");
      if (!table) return;
      table.setAttribute("role", "table");
      table.setAttribute("aria-colcount", String(count + 1));
      const label = table.querySelector(".compare-features");
      if (label) {
        label.id ||= "compare-table-title";
        table.setAttribute("aria-labelledby", label.id);
      }
      const header = table.querySelector(".compare-row-header > .flex");
      if (header) {
        header.setAttribute("role", "row");
        header.querySelector(".compare-col-labels")?.setAttribute("role", "columnheader");
        header.querySelectorAll(".jsResultItems > .compare-item").forEach((item, index) => {
          item.setAttribute("role", "columnheader");
          item.setAttribute("aria-colindex", String(index + 2));
          item.toggleAttribute("hidden", index >= count);
        });
      }
      const rows = table.querySelectorAll(".compare-group-info,compare-line-feature");
      rows.forEach((row) => {
        row.setAttribute("role", "row");
        const heading = row.querySelector(".compare-row-label,.compare-group-item-label");
        heading?.setAttribute("role", "rowheader");
        heading?.setAttribute("aria-colindex", "1");
        row.querySelectorAll(".jsCompareFeatures").forEach((cell, index) => {
          cell.setAttribute("role", "cell");
          cell.setAttribute("aria-colindex", String(index + 2));
          cell.toggleAttribute("hidden", index >= count);
        });
      });
    }
    toggleDetails(currentTarget) {
      if (!currentTarget) return;
      setTimeout(() => {
        const isOpen = currentTarget.open;
        this.querySelectorAll(".card-details details").forEach((item) => {
          item.open = isOpen;
        });
      }, 50);
    }
    onTouch() {
      const { left } = this.querySelector(".compare-table-details").getBoundingClientRect();
      if (left < 0 && this.lastPos != left) {
        this.classList.add("scrolling");
        this.lastPos = left;
        return;
      }
      left >= 0 && this.classList.remove("scrolling");
    }
    hideSimilar(event) {
      const { target } = event;
      this.querySelectorAll("compare-group-feature").forEach((item) => {
        item.hideSimilar = target.checked;
      });
    }
  });
  customElements.define("compare-group-feature", class extends HTMLElement {
    update() {
      this.querySelectorAll("compare-line-feature").forEach((item) => {
        item.checkEmpty();
      });
      this.toggleGroup();
    }
    set hideSimilar(value) {
      this.querySelectorAll("compare-line-feature:not(.hidden)").forEach((item) => {
        item.hideSimilar = value;
      });
      this.toggleGroup();
    }
    toggleGroup() {
      setTimeout(() => {
        const isHidden = this.querySelector(".jsCompareGroupFeature").scrollHeight <= 0;
        this.style.maxHeight = isHidden ? 0 : null;
        this.style.overflow = isHidden ? "hidden" : null;
      }, 50);
    }
  });
  customElements.define("compare-line-feature", class extends HTMLElement {
    checkEmpty() {
      const isHasContent = this.querySelector(".jsCompareFeatureValues").textContent.trim().length;
      this.classList.toggle("hidden", !isHasContent);
    }
    set hideSimilar(value) {
      if (!value) {
        this.classList.remove("hide-similar");
        return;
      }
      let arrayValues = [...this.querySelectorAll(".jsCompareFeatures.filled")].map((item) => item.textContent.trim());
      arrayValues = [...new Set(arrayValues)];
      arrayValues.length == 1 && this.classList.add("hide-similar");
    }
  });
})();
